module.exports = __webpack_public_path__ + "static/media/view-kn.152ef69a.svg";